module.exports = __webpack_public_path__ + "img/ScienceOutlined.7ca36481.svg";